// types
import { ReportColumnDto } from 'src/api';
// constants
import { stringAggregationModels } from '../constants/aggregation-model/string';

export function OwnerNameColumn(index: number) {
  const column = {
    field: 'ownerName',
    headerName: 'Owner name',
    description: 'Owner name column',
    type: 'string',
    index,
    width: 200,
    groupable: true,
    availableAggregationFunctions: stringAggregationModels,
    headerAlign: 'center',
    align: 'left',
  } as ReportColumnDto<any, any, any>;
  return column;
}
